import React from 'react';
import styles from './style.module.css';
import StepFourForm from '../../components/forms/step-four';

export default () => (
    <div className={styles.page}>
        <h1 className={styles.mainTitle}>How much will you pay up front?</h1>
        <StepFourForm />
    </div>
);
